import { ThemeResources, ThemeConstants } from 'owa-theme-shared';
import { getUserConfiguration } from 'owa-session-store';
import { isTenantThemeDataAvailable } from './isTenantThemeDataAvailable';
import { fetchThemeResource } from './fetchThemeResource';

export default function getCobrandingThemeResources(): ThemeResources {
    if (!isTenantThemeDataAvailable()) {
        return fetchThemeResource(ThemeConstants.BASE_THEME_ID, false);
    }

    let {
        ThemePrimary,
        ThemeSecondary,
        ThemeTertiary,
        ThemeDark,
        ThemeDarkAlt,
        ThemeDarker,
        ThemeLight,
        ThemeLightAlt,
        ThemeLighter,
        HeaderText,
        NavBarBackground,
    } = getUserConfiguration().TenantThemeData!;

    return {
        themePalette: {
            themePrimary: ThemePrimary!,
            themeSecondary: ThemeSecondary!,
            themeTertiary: ThemeTertiary!,
            themeDark: ThemeDark!,
            themeDarkAlt: ThemeDarkAlt!,
            themeDarker: ThemeDarker!,
            themeLight: ThemeLight!,
            themeLighterAlt: ThemeLightAlt!,
            themeLighter: ThemeLighter!,

            // TODO: should we adjust these for the various values, such as search values?
            headerBackground: NavBarBackground!,
            headerBackgroundSearch: NavBarBackground!,
            headerBrandText: HeaderText!,
            headerTextIcons: HeaderText!,
            headerSearchBoxBackground: 'rgba(255,255,255,.7)',
            headerSearchBoxIcon: ThemeDarker!,
            headerSearchPlaceholderText: ThemeDarker!,
            headerSearchButtonBackground: ThemePrimary!,
            headerSearchButtonBackgroundHover: ThemeDarker!,
            headerSearchButtonIcon: HeaderText!,
            headerSearchFilters: ThemePrimary!,
            headerSearchFiltersHover: ThemeDarker!,
            headerButtonsBackground: NavBarBackground!,
            headerButtonsBackgroundHover: ThemeDark!,
            headerButtonsBackgroundSearch: NavBarBackground!,
            headerButtonsBackgroundSearchHover: ThemeDark!,
            headerBadgeBackground: ThemeDarker!,
            headerBadgeText: HeaderText!,
            headerSearchIcon: HeaderText!,
            searchBoxBackground: 'rgba(255,255,255,.7)',
        },
    };
}
